import React from "react";
import classNames from "classnames";
import "./PersonFeed.scss";

const PersonFeed: React.FC<React.HTMLAttributes<HTMLElement>> = ({
  children,
  className
}) => {
  const classList = classNames({
    "person-feed": true,
    [`${className}`]: !!className,
  });
  return (
    <div className={classList}>
      <ul className="person-feed__list">
        {
          React.Children.map(children, (child, i) => (
            <li className="person-feed__list-item" key={`person-feed-item-${i}`}>
              {child}
            </li>
          ))
        }
      </ul>
    </div>
  );
};

export default PersonFeed;